import React from 'react';
import BentoCard from '../layout/BentoCard';
import { services } from '../../data/services';

/**
 * ServicesSection - What I Do section
 * Displays list of services offered
 */
const ServicesSection = () => {
  // Show only first 4 services for the grid card
  const featuredServices = services.slice(0, 4);

  return (
    <BentoCard span="1" delay={100}>
      <div className="p-6 h-full">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <span style={{ color: 'var(--color-accent)' }}>◈</span>
          What I Do
        </h2>

        <div className="space-y-4">
          {featuredServices.map((service) => (
            <div key={service.id} className="group">
              <div className="flex items-start gap-3">
                <span
                  className="text-lg transition-colors duration-300 group-hover:text-[var(--color-accent)]"
                  style={{ color: 'var(--color-text-muted)' }}
                >
                  {service.icon}
                </span>
                <div>
                  <h3 className="font-medium text-sm">{service.title}</h3>
                  <p
                    className="text-xs mt-1"
                    style={{ color: 'var(--color-text-muted)' }}
                  >
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </BentoCard>
  );
};

export default ServicesSection;
